import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "../../../../state/state.service";
import { IdentityVerificationState } from "../models/identity-verification-state.model";
import { IdentityVerificationInfo } from "../models/identity-verification.model";
import { IdVerseStateData } from "../models/identity-verification.model";

const initialState: IdentityVerificationState = null;

@Injectable({
  providedIn: "root",
})
export class IdentityVerificationStateService extends StateService<IdentityVerificationState> {
  constructor() {
    super(initialState);
  }

  getIdVerseState$(): Observable<IdVerseStateData> {
    return this.select((state: IdentityVerificationState) => state?.idVerseState);
  }

  getCurrentInfo$(): Observable<IdentityVerificationInfo> {
    return this.select((state: IdentityVerificationState) => state.currentIdentityVerificationInfo);
  }

  setIdVerseState(data: IdVerseStateData): void {
    const newState = {
      ...this.state,
      idVerseState: data,
    };
    this.setState(newState);
  }

  setCurrentInfo(data: IdentityVerificationInfo): void {
    const newState = {
      ...this.state,
      currentIdentityVerificationInfo: data
    };
    this.setState(newState);
  }

  isIdVerseStateLoaded(): boolean {
    return !!this.state?.idVerseState;
  }

  isCurrentIdentityVerificationInfoLoaded(): boolean {
    return !!this.state?.currentIdentityVerificationInfo;
  }

  clearState(): void {
    this.initState(initialState);
  }
}
